export enum WidgetButtonLayout {
  icon = "floating-icon",
  floatingTextButton = "floating-text-button",
  staticIcon = "static-icon",
  textButton = "text-button",
  noButton = "no-button", // used for when customers want to implement their
  // own custom button
}

export enum WidgetAlignment {
  left = "left",
  right = "right",
  center = "center",
  fullscreen = "fullscreen",
  inline = "inline",
}

export interface KahunaWidgetConfiguration {
  locale?: string;
  sessionId?: string;
  partnerId?: string;
  icon?: string;
  open?: boolean;
  utmString?: string;
  clinicId?: string;
  patientCaseId?: string;
  onCompletionUrl?: string;
  onAbandonUrl?: string;
  buttonLayout?: WidgetButtonLayout;
  buttonText?: string;
  windowAlignment?: WidgetAlignment;
  allowClosing?: boolean;
  nonPersist?: boolean;
  // undocumented flag we use to allow partners to display their own terms
  // agreement page and by-pas our landing page
  termsAgreed?: boolean;
  // Set this to true to make the widget get the setting straight a head
  // (loading time will be slower obviously)
  ignoreCache?: boolean;
  // Display a navigation bar in top of the chat
  navigationBar?: boolean;
}
